var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7.5"}}),_c('rect',{attrs:{"width":"2","height":"5.5","x":"6.5","y":"2.7","fill":"#FFF","rx":"1"}}),_c('rect',{attrs:{"width":"2","height":"2","x":"6.5","y":"9.7","fill":"#FFF","rx":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }